import React, { useState } from "react";
import { useRootAppStore } from "@hooks";
import classNames from "classnames";
import { observer } from "mobx-react";
import { ChannelResourceTypeDto } from "@api-types/chat";
import { ChatEntryPoint } from "@data-types/chat";

export default observer(function ChatButton(props: {
	// Is button displayed in main offer or additional offer and/or event view
	isOfferButton?: boolean;

	// Is button displayed in sport (red) header
	isInSportHeader?: boolean;

	// Is button displayed in offer/tournament header
	isInTournamentHeader?: boolean;

	// Is the button rendered in additional offer header
	isInEventHeader?: boolean;

	// Is button rendered on homepage in a sport header
	isHome?: boolean;

	channelType: ChannelResourceTypeDto;
	resourceId: string;
	sportAbrv?: string;
}) {
	const { chatViewStore } = useRootAppStore();

	const [isHover, setIsHover] = useState(false);

	if (!WEBPACK_IS_CHAT_AVAILABLE) {
		return null;
	}

	if (props.isHome) {
		return (
			<button
				className="offer--home__btn btn btn--square btn--square--reset btn--ghost"
				disabled={chatViewStore.isDisposing}
				onClick={() => {
					if (!chatViewStore.isDisposing) {
						chatViewStore.onInitialize(ChatEntryPoint.OFFER, {
							channelType: props.channelType,
							resourceId: props.resourceId,
							sportAbrv: props.sportAbrv,
						});
					}
				}}
				onMouseEnter={() => setIsHover(true)}
				onMouseLeave={() => setIsHover(false)}
				data-at="at-ChatButton--home"
			>
				<i
					className={classNames("u-icon u-icon--sml", {
						"u-icon--chat--alt": !isHover,
						"u-icon--chat--str": isHover,
					})}
				/>
			</button>
		);
	}

	const buttonClasses = classNames(
		"at-chatBtn",
		{
			offer__stats: props.isInSportHeader || props.isInTournamentHeader,
			event__actions__btn: props.isInEventHeader,
		},
		"btn btn--square",
		{
			"btn--square--sml btn--ghost": props.isInEventHeader,
			"btn--square--reset btn--ghost":
				props.isInSportHeader || props.isInTournamentHeader,
		}
	);

	const iconClasses = classNames(
		{
			offer__stats__icon:
				props.isInSportHeader || props.isInTournamentHeader,
			event__actions__icon: props.isInEventHeader,
		},
		"u-icon u-icon--sml",
		{
			"u-icon--chat--alt": !isHover,
			"u-icon--chat--str": isHover,
			"u-color--core--snow": props.isInSportHeader,
		}
	);

	return (
		<>
			<button
				className={buttonClasses}
				disabled={chatViewStore.isDisposing}
				onClick={() => {
					if (!chatViewStore.isDisposing) {
						chatViewStore.onInitialize(ChatEntryPoint.OFFER, {
							channelType: props.channelType,
							resourceId: props.resourceId,
							sportAbrv: props.sportAbrv,
						});
					}
				}}
				onMouseEnter={() => setIsHover(true)}
				onMouseLeave={() => setIsHover(false)}
			>
				<i className={iconClasses} />
			</button>
		</>
	);
});
